<div id="main-wrapper" [ngClass]="{'menu-toggle':toggleVal, 'show':true}" [class.iconhover-toggle]="mouseOvered">
    
    <app-nav-header [isOpen]="toggleVal" (sidebarToggle)="sidebarToggle($event)" />

    <app-chatbox />

    <app-header [dashboardTitle]="currentItem" />

    <app-navigation (mouseHoverEvent)="iconHoverToggle($event)" (newTitleEvent)="dashboardTitle($event)" (closeMenu)="toggleVal=false"/>

    <!-- Backdrop for mobile overlay sidebar -->
    <div *ngIf="toggleVal" class="sidebar-backdrop" (click)="toggleVal = false"></div>

    <!-- Global operations toolbar (oculta en POS) -->
    <app-ops-toolbar *ngIf="!hideOpsToolbar"></app-ops-toolbar>

    <router-outlet />

    <app-footer />
</div>